import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { ErrorBannerState } from './error-banner.reducer';

const errorBannerState = (state: RootState): ErrorBannerState | undefined => state.errorBanner;

export const errorBannerSelector = createSelector(errorBannerState, (state) => state?.banner);
